import React from "react";
import { Link, useLocation , useParams} from "react-router-dom";
import Star from "../assets/images/Star.svg";
import MediImg from "../assets/images/medicinesImg.svg";

const Subheader = ({category_item}) => {
  let currentRoute = useLocation().pathname;
  const { id } = useParams(); 
  return (
    <>
      {currentRoute === "/AllSellers" || currentRoute === "/PetAllSellers" ? (
        <>
          <div className="allSellersBox">
            <div className="headingTxt">
              <h1>All Sellers</h1>
            </div>
            <div className="rightSideBox">
              <div className="txt">
                <label htmlFor="" className="nameIn">
                  Pet Supplements for Dog
                </label>
                <label htmlFor="" className="rating">
                  <img src={Star} alt="" /> 4.3 (1200)
                </label>
              </div>
              <div className="imgHolder">
                <img src={MediImg} className="MediImg" alt="" />
              </div>
            </div>
          </div>
        </>
      ) : (
        <div
          className={
            currentRoute === "/DoctorDetails" ||
              currentRoute === "/BookAppoitment" ||
              currentRoute === "/ProductDetails" ||
              currentRoute === "/MedicinesCart" ||
              currentRoute === "/MedicineCheckout" ||
              currentRoute === "/PetShopDetails" ||
              currentRoute === "/Cart" ||
              currentRoute === "/Checkout" ||  currentRoute === "/menu"
              ? "subHeaderMainsmall"
              : "subHeaderMainBig"
          }
        >
          <div className="landingImg">

          {/* <img  src={category_item.category_image_url} alt="image not found" /> */}
          </div>
          {
            // Doctor's Routes
            (currentRoute === "/DoctorsList" && <h1>Doctor's</h1>) ||
            (currentRoute === "/BookAppoitment" && (
              <h1>Book Appointment</h1>
            )) ||
            (currentRoute === "/DoctorDetails" && <h1>Doctor Details</h1>) ||
            // Medicines Routes
            (currentRoute === "/Medicines" && <h1>Medicines</h1>) ||
            (currentRoute === "/ProductDetails" || currentRoute === "/PetShopDetails" ? (
              <h1>Product Description</h1>
            ) : null) ||
            (currentRoute === "/MedicinesCart" || currentRoute === "/Cart" ? <h1>Cart</h1> : null) ||
            (currentRoute === "/MedicineCheckout" || currentRoute === "/Checkout" ? <h1> Checkout</h1> : null) ||
            (currentRoute === "/PetShops" && <h1>fvget / Vet Shop</h1>)||
            (currentRoute === "/AmbulanceBook" && <h1>Request Ambulance</h1>) ||
            (currentRoute === "/ProfileSetting" && <h1>My Account</h1>) ||
          
            (currentRoute === `/MyOrderDetails/${id}` && <h1>Order Status</h1>) || 
            (currentRoute === `/menu` && <h1>Menu</h1>) 

            
          
          }
        
        </div >
      )}

      {/* BreadCrumbs For Ux */}
      <div div className="breakCrumbs">
        {
          // Doctors
          (currentRoute === "/DoctorsList" && (
            <>
              <Link to="/Home" className="BackLink">
                Home<span className="slashPower">/</span>
              </Link>
              <Link to="#" className="frontLink">
                Doctor
              </Link>
            </>
          )) ||
          (currentRoute === "/DoctorDetails" && (
            <>
              <Link to="/Home" className="BackLink">
                Home<span className="slashPowerSame">/</span>
              </Link>
              <Link to="/DoctorsList" className="BackLink">
                Doctor<span className="slashPower">/</span>
              </Link>
              <Link to="#" className="frontLink">
                Doctor Details
              </Link>
            </>
          )) ||
          (currentRoute === "/BookAppoitment" && (
            <>
              <Link to="/Home" className="BackLink">
                Home<span className="slashPowerSame">/</span>
              </Link>
              <Link to="/DoctorsList" className="BackLink">
                Doctor<span className="slashPowerSame">/</span>
              </Link>
              <Link to="/DoctorDetails" className="BackLink">
                Doctor Details<span className="slashPower">/</span>
              </Link>
              <Link to="#" className="frontLink">
                Book Appointment
              </Link>
            </>
          )) ||
          // Medicines
          (currentRoute === "/Medicines" && (
            <>
              <Link to="/Home" className="BackLink">
                Home<span className="slashPower">/</span>
              </Link>
              <Link to="#" className="frontLink">
                Medicines
              </Link>
            </>
          )) ||
          (currentRoute === "/ProductDetails" ||
            currentRoute === "/AllSellers" ? (
            <>
              <Link to="/Home" className="BackLink">
                Home<span className="slashPowerSame">/</span>
              </Link>
              <Link to="/Medicines" className="BackLink">
                Medicines<span className="slashPower">/</span>
              </Link>
              <Link to="#" className="frontLink">
                Product Description
              </Link>
            </>
          ) : null) ||
          (currentRoute === "/MedicinesCart" || currentRoute === "/Cart" ? (
            <>
              <Link to="/Home" className="BackLink">
                Home<span className="slashPower">/</span>
              </Link>
              <Link to="#" className="frontLink">
                Cart
              </Link>
            </>
          ) : null)
          ||
          (currentRoute === "/MedicineCheckout" || currentRoute === "/Checkout" ? (
            <>
              <Link to="/Home" className="BackLink">
                Home<span className="slashPower">/</span>
              </Link>
              <Link to="#" className="frontLink">
                Checkout
              </Link>
            </>
          ) : null) ||
          (currentRoute === "/PetShops" && (
            <>
              <Link to="/Home" className="BackLink">
                Home<span className="slashPower">/</span>
              </Link>
              <Link to="#" className="frontLink">
                Pet Shop Products
              </Link>
            </>
          )) ||
          (currentRoute === "/PetShopDetails" ||
            currentRoute === "/PetAllSellers" ? (
            <>
              <Link to="/Home" className="BackLink">
                Home<span className="slashPowerSame">/</span>
              </Link>
              <Link to="/PetShops" className="BackLink">
                Pet or Vet Shop<span className="slashPower">/</span>
              </Link>
              <Link to="#" className="frontLink">
                Product Description
              </Link>
            </>
          ) : null) ||
          (currentRoute === "/ProfileSetting" && (
            <>
              <Link to="/Home" className="BackLink">
                Home<span className="slashPowerSame">/</span>
              </Link>

              <Link to="#" className="frontLink">
                My Account
              </Link>
            </>
          )) ||
          (currentRoute === "/AmbulanceBook" && (
            <>
              <Link to="/Home" className="BackLink">
                Home<span className="slashPowerSame">/</span>
              </Link>
              <Link to="/ProfileSetting" className="BackLink">
                My Accounts<span className="slashPower">/</span>
              </Link>
              <Link to="#" className="frontLink">
                Request Ambulance
              </Link>
            </>
          ))
        }
      </div>
    </>
  );
};

export default Subheader;
